//ALWAYS IMPORT ONLY THE COMPONENT YOU NEED FROM MATERIAL
export { default, FormLabelProps } from '@mui/material/FormLabel';
